import {combineReducers} from 'redux';
// lets us dispatch() functions
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose }  from 'redux';
import { createLogger } from 'redux-logger';
import emailVerifyInput from '../reducers/email-verify-input';

// neat middleware that logs actions
const loggerMiddleware = createLogger();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    emailVerifyInput: emailVerifyInput
});

function applyAllMiddleware(){
    //only log in dev
    if(process.env.NODE_ENV === 'dev'){
        return applyMiddleware(thunkMiddleware,loggerMiddleware);
    } else {
        return applyMiddleware(thunkMiddleware);
    }
}

const store = createStore(
    rootReducer,
    composeEnhancers(
        applyAllMiddleware()
    )
);

window.reduxStore_emailVerifyInput = store;

export default store;
